import { LISTS_EVENTS as Event } from './events';
import { fireEvent } from '../index';
import Modules from '../modules';

export const trackContactList = (clientName: string) => {
  fireEvent(Event.CONTACT_LIST, { tenant_name: clientName, moduleName: Modules.List });
};

export const trackAccountList = (clientName: string) => {
  fireEvent(Event.ACCOUNT_LIST, { tenant_name: clientName, moduleName: Modules.List });
};

export const trackListSelected = (clientName: string, list_name: string) => {
  fireEvent(Event.LIST_SELECTED, { tenant_name: clientName, list_name, moduleName: Modules.List });
};

export const trackListExport = (clientName: string, list_name: string) => {
  fireEvent(Event.ACTIONS.LIST_EXPORT, { tenant_name: clientName, list_name });
};

export const trackHpmMessageClick = (clientName: string) => {
  fireEvent(Event.HPM.AI_MESSAGE, { tenant_name: clientName, moduleName: Modules.List });
};

export const trackHpmGenerate = (clientName: string) => {
  fireEvent(Event.HPM.GENERATE_HPM, { tenant_name: clientName });
};

export const trackHpmAutoGenerate = (clientName: string) => {
  fireEvent(Event.HPM.AUTO_GENERATE, { tenant_name: clientName });
};

export const trackHpmAutoGenerateConfirm = (clientName: string) => {
  fireEvent(Event.HPM.AUTO_GENERATE_CONFIRM, { tenant_name: clientName });
};

export const trackCustomPrompt = (clientName: string) => {
  fireEvent(Event.HPM.CUSTOM_PROMPT, { tenant_name: clientName });
};

export const trackCustomPromptConfirm = (clientName: string) => {
  fireEvent(Event.HPM.CUSTOM_PROMPT_CONFIRM, { tenant_name: clientName });
};

export const trackListBulkSelection = (
  moduleName: 'ACCOUNT' | 'CONTACT',
  clientName: string,
  selectionType: 'SELECT_THIS_PAGE' | 'SELECT_ALL' | 'SELECT_CUSTOM',
  customCount?: number,
) => {
  const eventContext = moduleName === 'ACCOUNT' ? 'ACCOUNT_LIST' : 'CONTACT_LIST';
  const selection = moduleName === 'ACCOUNT' ? 'Accounts' : 'Contacts';

  switch (selectionType) {
    case 'SELECT_THIS_PAGE':
      fireEvent(
        `${Event[eventContext]} - Selected ${selection} - ${Event.BULK_SELECTION.SELECT_THIS_PAGE}`,
        { tenant_name: clientName },
      );
      break;
    case 'SELECT_ALL':
      fireEvent(
        `${Event[eventContext]} - Selected ${selection} - ${Event.BULK_SELECTION.SELECT_ALL}`,
        {
          tenant_name: clientName,
          moduleName: Modules.List,
        },
      );
      break;
    case 'SELECT_CUSTOM':
      fireEvent(
        `${Event[eventContext]} - Selected ${selection} - ${Event.BULK_SELECTION.SELECT_CUSTOM}`,
        {
          tenant_name: clientName,
          custom_count: customCount,
          moduleName: Modules.List,
        },
      );
      break;
  }
};

export const trackListSendToCMPClicked = (clientName: string) => {
  fireEvent(Event.SEND_TO_CMP.SEND_TO_CMP_CLICKED, {
    tenant_name: clientName,
    moduleName: Modules.List,
  });
};

export const trackListSendToCMPConfirm = (clientName: string) => {
  fireEvent(Event.SEND_TO_CMP.SEND_TO_CMP_CONFIRM, {
    tenant_name: clientName,
    moduleName: Modules.List,
  });
};

export const trackListSendToCMPCancel = (clientName: string) => {
  fireEvent(Event.SEND_TO_CMP.SEND_TO_CMP_CANCEL, { tenant_name: clientName });
};
